import api from "!../../../../../frontend/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../frontend/node_modules/css-loader/dist/cjs.js!../../../../../frontend/node_modules/sass-loader/dist/cjs.js!./colors.module.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};